module.exports = __webpack_public_path__ + "static/media/Icond-3.090f6c45.svg";